export default "__VITE_ASSET__CJKDCDyw__"